<app-autocomplete
  class="form-field"
  aria="Dock Group"
  [form]="form"
  controlName="inputControl"
  valueProperty="name"
  [options]="menuOptions"
  [requireSelection]="true"
  [displayProperties]="['name']"
  [placeholder]="placeholder" />
